<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>location_city</mat-icon>
      Pick Organisation
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section align="end" mat-dialog-actions>
    <search-text (search)="setSearch($event)"></search-text>
  </section>
  @if (!loading) {
    <section mat-dialog-content>
      <mat-table #table [dataSource]="DataSource">
        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row.title}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
          <mat-cell *matCellDef="let row" class="actions">
            <button mat-icon-button matTooltip="Select organisation.">
              <mat-icon
                >{{ selectedOrganisation?.id == row.id && 'radio_button_checked'
                || 'radio_button_unchecked' }}
              </mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          (click)="setSelectedOrganisation(row.id, row.has_branches)"
          *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{selected: selectedOrganisation?.id == row.id}"
        ></mat-row>
      </mat-table>
    </section>
  }
  @if (!!PageEvent) {
    <section align="end" mat-dialog-actions>
      @if (PageEvent) {
        <mat-paginator
          (page)="DataSource.loadWithPageEvent($event)"
          [length]="PageEvent.length"
          [pageIndex]="PageEvent.pageIndex"
          [pageSize]="PageEvent.pageSize"
        ></mat-paginator>
      }
    </section>
  }
  <section align="end" mat-dialog-actions>
    <button
      (click)="selectOrganisation()"
      [disabled]="!selectedOrganisation"
      mat-button
      >
      <mat-icon>done</mat-icon>
      Select
    </button>
  </section>
</section>
